/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EstimatedRevenueDto } from '../../models/estimated-revenue-dto';

export interface GetEstimatedRevenue$Params {
  id: string;
}

export function getEstimatedRevenue(http: HttpClient, rootUrl: string, params: GetEstimatedRevenue$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedRevenueDto>> {
  const rb = new RequestBuilder(rootUrl, getEstimatedRevenue.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EstimatedRevenueDto>;
    })
  );
}

getEstimatedRevenue.PATH = '/v0/estimatedRevenue/{id}';
